import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33d3461c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "couriers" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center my-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка QR...", -1))
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col items-center justify-between"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "bg-white rounded mt-3" }
const _hoisted_9 = { class: "py-3 px-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-filter mr-2" }, null, -1))
const _hoisted_11 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_12 = { class: "mt-1 flex items-center justify-end" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_15 = { class: "flex items-center justify-end mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_17 = { class: "mt-3" }
const _hoisted_18 = {
  key: 1,
  class: "flex flex-col items-center justify-center my-3"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка...", -1))
const _hoisted_20 = { class: "flex items-center justify-end py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_couriers_table_row = _resolveComponent("couriers-table-row")!
  const _component_couriers_table_row_actions = _resolveComponent("couriers-table-row-actions")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.phone_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Редактирование номера телефона",
          loading: _ctx.phone_state.is_loading,
          onSubmit: _ctx.setPhone,
          onCancel: _ctx.toggleSetPhone
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_input, {
              value: _ctx.phone_state.phoneNumber,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone_state.phoneNumber) = $event)),
              placeholder: "Номер телефона",
              "is-invalid": !_ctx.phone_state.phoneNumber,
              disabled: _ctx.phone_state.is_loading,
              maska: _ctx.PHONE_NUMBER_MASK
            }, null, 8, ["value", "is-invalid", "disabled", "maska"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.qr_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 1,
          title: "QR код курьера",
          loading: _ctx.qr_state.is_loading,
          class: "NewModal__square",
          "without-footer": "",
          onCancel: _ctx.toggleQr
        }, {
          default: _withCtx(() => [
            (_ctx.qr_state.is_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_3
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.qr_state.img,
                    alt: "qr_img"
                  }, null, 8, _hoisted_5),
                  _createVNode(_component_new_button, {
                    disabled: _ctx.qr_state.is_loading,
                    loading: _ctx.qr_state.is_loading,
                    onClick: _ctx.downloadQr,
                    class: "NewButton--search mt-2"
                  }, {
                    "icon-left": _withCtx(() => [
                      _hoisted_6
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Скачать QR ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"])
                ]))
          ]),
          _: 1
        }, 8, ["loading", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.excel_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 2,
          title: "Скачивание Excel",
          loading: _ctx.excel_state.is_loading,
          onSubmit: _ctx.exportExcel,
          onCancel: _ctx.toggleExcel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_new_input, {
                class: "mr-2",
                type: "date",
                value: _ctx.excel_state.fromDate,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.excel_state.fromDate) = $event)),
                name: "Дата с",
                placeholder: "Выберите дату",
                disabled: _ctx.excel_state.is_loading
              }, null, 8, ["value", "disabled"]),
              _createVNode(_component_new_input, {
                type: "date",
                value: _ctx.excel_state.toDate,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.excel_state.toDate) = $event)),
                name: "Дата по",
                placeholder: "Выберите дату",
                disabled: _ctx.excel_state.is_loading
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Курьеры" }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_new_button, {
          disabled: _ctx.state.is_loading,
          class: "NewButton--outline",
          onClick: _ctx.toggleFilters
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" Фильтр ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _withDirectives(_createElementVNode("form", {
          class: "mt-4",
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFilters && _ctx.submitFilters(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              type: "date",
              placeholder: "Выберите дату",
              value: _ctx.filters_state.createdAtFrom,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.createdAtFrom) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              type: "date",
              placeholder: "Выберите дату",
              value: _ctx.filters_state.createdAtUntil,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.createdAtUntil) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_select, {
              disabled: _ctx.state.is_loading,
              placeholder: "Статус курьера",
              options: _ctx.COURIER_STATUSES,
              multiselect: "",
              value: _ctx.filters_state.statusIds,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.statusIds) = $event)),
              searchable: false
            }, null, 8, ["disabled", "options", "value"]),
            _createVNode(_component_new_select, {
              disabled: _ctx.state.is_loading,
              placeholder: "Статус смены",
              options: _ctx.COURIER_SHIFTS,
              value: _ctx.filters_state.shiftId,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.shiftId) = $event)),
              searchable: false
            }, null, 8, ["disabled", "options", "value"]),
            _createVNode(_component_new_select, {
              disabled: _ctx.state.is_loading,
              placeholder: "Выберите сектор",
              loading: _ctx.dispatcher_sectors_state.is_loading,
              failed: _ctx.dispatcher_sectors_state.is_failed,
              "error-text": "При получении секторов диспетчера произошла ошибка",
              options: _ctx.dispatcher_sectors_state.list,
              multiselect: "",
              "search-without-refresh": "",
              value: _ctx.filters_state.dispatcherSectorIds,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.dispatcherSectorIds) = $event)),
              onRefresh: _ctx.loadDispatcherSectors
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
            _createVNode(_component_new_select, {
              placeholder: "Выберите поставщика",
              disabled: _ctx.state.is_loading,
              loading: _ctx.companies_state.is_loading,
              failed: _ctx.companies_state.is_failed,
              "error-text": "При получении списка поставщиков произошла ошибка",
              options: _ctx.companies_state.list,
              value: _ctx.filters_state.companyId,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
              "search-without-refresh": "",
              onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadCompanies(1)))
            }, null, 8, ["disabled", "loading", "failed", "options", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Укажите ФИО",
              value: _ctx.filters_state.name,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters_state.name) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Укажите ИИН",
              value: _ctx.filters_state.iin,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters_state.iin) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Укажите телефон",
              value: _ctx.filters_state.phoneNumber,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.phoneNumber) = $event)),
              maska: _ctx.PHONE_NUMBER_MASK
            }, null, 8, ["disabled", "value", "maska"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Укажите марку авто",
              value: _ctx.filters_state.carModel,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters_state.carModel) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Укажите гос. номер",
              value: _ctx.filters_state.carNumber,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters_state.carNumber) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "ID",
              value: _ctx.filters_state.id,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters_state.id) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_select, {
              placeholder: "Выберите тип курьера",
              label: "title",
              "select-by": "id",
              multiselect: "",
              disabled: _ctx.state.is_loading,
              loading: _ctx.types_state.is_loading,
              failed: _ctx.types_state.is_failed,
              searchable: false,
              options: _ctx.types_state.list,
              "error-text": "При получении списка типов курьера произошла ошибка",
              value: _ctx.filters_state.typesIds,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters_state.typesIds) = $event)),
              "search-without-refresh": "",
              onRefresh: _ctx.loadTypes
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              class: "NewButton--reset mr-2",
              onClick: _ctx.resetFilters
            }, {
              "icon-left": _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              loading: _ctx.state.is_loading,
              class: "NewButton--search",
              type: "submit"
            }, {
              "icon-left": _withCtx(() => [
                _hoisted_14
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Поиск ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ], 544), [
          [_vShow, _ctx.filters_state.is_opened]
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_new_button, {
            disabled: _ctx.state.is_loading,
            hint: "Скачать Excel",
            class: "mr-3",
            onClick: _ctx.toggleExcel
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_new_limit, {
            disabled: _ctx.state.is_loading,
            value: _ctx.state.limit,
            "total-items": _ctx.state.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.state.is_loading,
            "current-page": _ctx.state.current_page,
            "total-pages": _ctx.state.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.state.is_failed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка курьеров произошла ошибка",
              onRefresh: _ctx.loadCouriers
            }, null, 8, ["loading", "onRefresh"]))
          : (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_19
              ]))
            : (_openBlock(), _createBlock(_component_new_table, {
                key: 2,
                class: "mt-3",
                columns: _ctx.COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_couriers_table_row, {
                    column: column,
                    row: row
                  }, null, 8, ["column", "row"])
                ]),
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_couriers_table_row_actions, {
                    courier: row,
                    "can-update": _ctx.isCanUpdate,
                    onSetPhone: _ctx.toggleSetPhone,
                    onRouting: _ctx.loadCouriers,
                    onQr: _ctx.toggleQr
                  }, null, 8, ["courier", "can-update", "onSetPhone", "onRouting", "onQr"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_new_limit, {
            disabled: _ctx.state.is_loading,
            value: _ctx.state.limit,
            "total-items": _ctx.state.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.state.is_loading,
            "current-page": _ctx.state.current_page,
            "total-pages": _ctx.state.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ])
      ])
    ])
  ]))
}